/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgMenuArrowRightBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.4211 13.3549C13.8353 13.3549 14.1711 13.6907 14.1711 14.1049C14.1711 14.5191 13.8353 14.8549 13.4211 14.8549V13.3549ZM3 14.8549C2.58579 14.8549 2.25 14.5191 2.25 14.1049C2.25 13.6907 2.58579 13.3549 3 13.3549V14.8549ZM13.4211 18.25C13.8353 18.25 14.1711 18.5858 14.1711 19C14.1711 19.4142 13.8353 19.75 13.4211 19.75V18.25ZM3 19.75C2.58579 19.75 2.25 19.4142 2.25 19C2.25 18.5858 2.58579 18.25 3 18.25L3 19.75ZM20.0527 8.45978C20.4669 8.45978 20.8027 8.79557 20.8027 9.20978C20.8027 9.624 20.4669 9.95978 20.0527 9.95978V8.45978ZM3 9.95978C2.58579 9.95978 2.25 9.624 2.25 9.20978C2.25 8.79557 2.58579 8.45978 3 8.45978V9.95978ZM17.132 5.45626C16.88 5.1275 16.9423 4.65673 17.271 4.40474C17.5998 4.15276 18.0705 4.21499 18.3225 4.54374L17.132 5.45626ZM21 9.26981L21.5953 8.81355C21.8032 9.08487 21.8014 9.4625 21.5908 9.7318L21 9.26981ZM18.3181 13.9172C18.0629 14.2435 17.5916 14.3012 17.2653 14.046C16.939 13.7909 16.8813 13.3195 17.1364 12.9932L18.3181 13.9172ZM13.4211 14.8549H3V13.3549H13.4211V14.8549ZM13.4211 19.75H3L3 18.25H13.4211V19.75ZM20.0527 9.95978L3 9.95978V8.45978L20.0527 8.45978V9.95978ZM18.3225 4.54374L21.5953 8.81355L20.4047 9.72606L17.132 5.45626L18.3225 4.54374ZM21.5908 9.7318L18.3181 13.9172L17.1364 12.9932L20.4092 8.80782L21.5908 9.7318Z"
      fill="currentColor"
    />
  </svg>
);
const SvgMenuArrowRight = wrapIcon(SvgMenuArrowRightBase);
export default SvgMenuArrowRight;
